import { useMutation } from "@apollo/client";

import { STAND_COMMENT_DELETE } from "graphql/mutation/stand-gql";
import { successNotification, errorNotification } from "components/request-result";


const useMutationStandCommentDelete = ({
    showSuccessNotification = true,
    showErrorNotification = true,
    onCompleted = () => {},
    onError = () => {},
} = {}) => {
    const [ _setStandCommentDelete, { loading } ] = useMutation(STAND_COMMENT_DELETE, {
        update(cache, { data }) {
            const payload = data?.commentDelete;
            if (showSuccessNotification && payload?.label) {
                successNotification({
                    title: payload.label,
                    description: payload.message,
                });
            }
            onCompleted(payload);
        },
        onError(error) {
            if (showErrorNotification) {
                errorNotification(error);
            }
            onError(error);
        },
    });

    return {
        _setStandCommentDelete,
        loadingMutationStandCommentDelete: loading,
    };
};

export default useMutationStandCommentDelete;
